<template>
  <div class="two-columns gutter-lg mb body">
    <slot name="fullWidth"></slot>
    <div class="flex-container">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoColumns',
  props: [
    'copy'
  ],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/_vars';
  .flex-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    @media(min-width: $screen-sm-min) {
      flex-direction: row;
    }
    > div {
      width: 100%;
      flex-shrink: 0;
      @media(min-width: $screen-sm-min) {
        width: 50%;
      }
    }
  }

  ul {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwoColumns.vue